




















































































































































































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import { AttendeesDto, AttendeesListDto, PresentationEventDto } from '@/dto';
import { CodeManagementDto } from '@/services/init/dto/index.js';
import CodeManagementService from '../../../services/code-management.service';
import PresentationEventService from '@/services/presentation-event.service';
import AttendeesService from '@/services/attendees.service';
import FileUploadService, {
  UPLOAD_TYPE,
} from '@/services/shared/file-upload/file-upload.service';
import {
  ATTACHMENT_REASON_TYPE,
  FileAttachmentDto,
} from '@/services/shared/file-upload';

import toast from '../../../../resources/assets/js/services/toast.js';
import router from '@/router';
import { CONST_YN, Pagination, YN } from '@/common';
import { CONST_PAGINATION_COUNT, PaginationCount } from '@/services/shared';
import { ReverseQueryParamMapper, RouterQueryParamMapper } from '@/core';

@Component({
  name: 'PresentationEventDetail',
})
export default class PresentationEventDetail extends BaseComponent {
  private attendeesList: AttendeesDto[] = [];
  private attendeesTotalCount = null;
  private attendeesSearchDto = new AttendeesListDto();
  private attendeesCreateDto = new AttendeesDto();
  private attendeesDto = new AttendeesDto();
  private paginationAttendees = new Pagination();

  private presentationEventDto = new PresentationEventDto();
  private newAttachments: FileAttachmentDto[] = [];
  private newMobileAttachments: FileAttachmentDto[] = [];
  private eventTypeSelect: CodeManagementDto[] = [];
  private displayTypeSelect: CodeManagementDto[] = [];
  private genderSelect: CodeManagementDto[] = [];
  private scheduleList = ['11시 오전', '2시 오후'];
  private onlineScheduleList = [
    '25일(월)',
    '26일(화)',
    '27일(수)',
    '28일(목)',
    '29일(금)',
  ];
  private imageChanged = false;
  private mobileImageChanged = false;
  private ynSelect: YN[] = [...CONST_YN];
  private dataLoading = false;
  private newDate = new Date();
  private newLimit = null;
  private paginationCount: PaginationCount[] = [...CONST_PAGINATION_COUNT];
  // excel options
  private fields = {
    회원여부: 'isNanudaUser',
    이름: 'name',
    연락처: 'phone',
    성별: 'genderInfo.value',
    계약여부: 'isContracted',
    이전참석여부: 'isAttended',
    참석시간대: 'scheduleTime',
  };
  private json_meta = [
    [
      {
        key: 'charset',
        value: 'utf-8',
      },
    ],
  ];

  findOne(id) {
    PresentationEventService.findOne(this.$route.params.id).subscribe(res => {
      if (res) {
        this.presentationEventDto = res.data;
      }
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    this.paginationAttendees.limit = this.newLimit;
    this.attendeesSearchDto.eventNo = parseInt(this.$route.params.id);
    if (!isPagination) {
      this.paginationAttendees.page = 1;
    } else {
      if (isSearch) this.paginationAttendees.page = 1;
      RouterQueryParamMapper(this.attendeesSearchDto, this.paginationAttendees);
    }
    AttendeesService.findAll(
      this.attendeesSearchDto,
      this.paginationAttendees,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.attendeesList = res.data.items;
        this.attendeesTotalCount = res.data.totalCount;
      }
    });
  }

  findAttendee(attendeeNo) {
    AttendeesService.findOne(attendeeNo).subscribe(res => {
      this.attendeesDto = res.data;
    });
  }

  createAttendee() {
    this.attendeesCreateDto.eventNo = parseInt(this.$route.params.id);
    AttendeesService.create(this.attendeesCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가 완료');
        this.findAll();
      }
    });
  }

  clearOutCreateDto() {
    this.attendeesCreateDto = new AttendeesDto();
  }

  updateAttendee(attendeeNo) {
    AttendeesService.update(attendeeNo, this.attendeesDto).subscribe(res => {
      if (res) {
        toast.success('수정 완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  deleteOne() {
    PresentationEventService.deleteForAdmin(this.$route.params.id).subscribe(
      res => {
        if (res) {
          toast.success('삭제 완료');
          this.$router.push('/presentation-event');
        }
      },
    );
  }

  // 이미지 업로드
  async uploadMainImage(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(
        UPLOAD_TYPE.PRESENTATION_EVENT,
        [file],
      );
      this.newAttachments = [];
      this.newAttachments.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.imageChanged = true;
    }
  }

  removeImage() {
    this.newAttachments = [];
    this.$refs['fileInput'].reset();
    this.imageChanged = false;
  }

  async uploadMobileImage(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(
        UPLOAD_TYPE.PRESENTATION_EVENT,
        [file],
      );
      this.newMobileAttachments = [];
      this.newMobileAttachments.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.mobileImageChanged = true;
    }
  }

  removeMobileImage() {
    this.newMobileAttachments = [];
    this.$refs['fileInputMobile'].reset();
    this.mobileImageChanged = false;
  }

  updateEvent() {
    if (this.newAttachments.length > 0) {
      this.presentationEventDto.image = this.newAttachments;
    } else {
      delete this.presentationEventDto.image;
    }

    if (this.newMobileAttachments.length > 0) {
      this.presentationEventDto.mobileImage = this.newMobileAttachments;
    } else {
      delete this.presentationEventDto.mobileImage;
    }

    PresentationEventService.update(
      this.presentationEventDto.no,
      this.presentationEventDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정 완료');
        this.findOne(this.presentationEventDto.no);
      }
    });
  }

  // 성별
  getGender() {
    CodeManagementService.findGender().subscribe(res => {
      this.genderSelect = res.data;
    });
  }

  created() {
    this.findOne(this.$route.params.id);
    this.newLimit = PaginationCount.TWENTY;
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.attendeesSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.paginationAttendees.limit = +query.limit;
        this.paginationAttendees.page = +query.page;
      } else {
        this.paginationAttendees = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCommonCodes('eventTypeSelect', 'PRESENTATION_EVENT_TYPE');
    this.getCommonCodes('displayTypeSelect', 'PRESENTATION_DISPLAY_TYPE');
    this.getGender();
  }
}
